import gql from "graphql-tag";

const queryCreate = gql`
  mutation($name: String!, $description: String, $actionsAvailableIds: [ID!], $possessionsAvailableIds: [ID!]) {
    createModule(data: { name: $name, description: $description,actionsAvailableIds: $actionsAvailableIds, possessionsAvailableIds: $possessionsAvailableIds  }) {
      id
      name
      description
      updatedAt
      createdAt
    }
  }
`;

const queryUpdate = gql`
  mutation($id: ID!, $name: String, $description: String, $actionsAvailableIds: [ID!], $possessionsAvailableIds: [ID!]) {
    updateModule(
      id: $id
      data: { name: $name, description: $description, actionsAvailableIds: $actionsAvailableIds, possessionsAvailableIds: $possessionsAvailableIds }
    ) {
      id
      name
  
      updatedAt
      createdAt
    }
  }
`;

const queryDelete = gql`
  mutation($id: ID!) {
    deleteModule(id: $id) {
      id
    }
  }
`;

const queryGetAll = gql`
  query {
    getAllModule {
      id
      name
      description
      updatedAt
      createdAt
    }
  }
`;

const queryGet = gql`
  query($id: ID!) {
    getModule(id: $id) {
      id
      name
      updatedAt
      createdAt
      description
      actionsAvailable{id}
      possessionsAvailable{id}
      author {
        id
        fullname
      }
    }
  }
`;

const queryGetListNameModule = gql`
  query {
    getListNameModule
  }
`;
const queryGetAllPermissionPossession = gql`
  query {
    getAllPermissionPossession {
      id
      name
      description
      updatedAt
      createdAt
    }
  }
`;

const queryAllPermissionAction  = gql`
  query {
    getAllPermissionAction {
      id
      name
      description
      updatedAt
      createdAt
    }
  }
`;


export default {
  queryCreate,
  queryUpdate,
  queryDelete,
  queryGetAll,
  queryGet,
  queryGetListNameModule,
  queryGetAllPermissionPossession,
  queryAllPermissionAction,
};
